import React, { useState, useEffect, useRef } from 'react';
import FadeIn from './FadeIn';

const cateringPhotos = [
  "https://ik.imagekit.io/aeu02xvjgn/2020-06-10-Padua-Menu-0169.jpg",
  "https://ik.imagekit.io/aeu02xvjgn/2020-06-10-Padua-Menu-0250.jpg",
  "https://ik.imagekit.io/aeu02xvjgn/2020-06-10-Padua-Menu-0322.jpg",
  "https://ik.imagekit.io/aeu02xvjgn/2020-06-10-Padua-Menu-0292.jpg",
  "https://ik.imagekit.io/aeu02xvjgn/2020-06-10-Padua-Menu-0271.jpg",
];

const CateringCarousel = () => {
  const [current, setCurrent] = useState(0);
  const [loaded, setLoaded] = useState({});
  const timerRef = useRef(null);

  useEffect(() => {
    // Preload all images
    cateringPhotos.forEach((src, i) => {
      const img = new Image();
      img.onload = () => setLoaded(prev => ({ ...prev, [i]: true }));
      img.src = src;
    });
  }, []);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCurrent(c => (c + 1) % cateringPhotos.length);
    }, 3500);
    return () => clearInterval(timerRef.current);
  }, []);

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '520px',
        overflow: 'hidden',
        border: '10px solid #FCFAF6',
        boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
      }}
    >
      {cateringPhotos.map((src, i) => (
        <img
          key={i}
          src={src}
          alt={`Catering photo ${i + 1}`}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: i === current ? 1 : 0,
            transition: 'opacity 0.9s ease-in-out',
            zIndex: i === current ? 1 : 0,
          }}
        />
      ))}

      {/* Dots */}
      <div
        style={{
          position: 'absolute',
          bottom: '16px',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '6px',
          zIndex: 10,
        }}
      >
        {cateringPhotos.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            aria-label={`Photo ${i + 1}`}
            style={{
              height: '4px',
              width: i === current ? '24px' : '6px',
              borderRadius: '9999px',
              backgroundColor: i === current ? '#FCFAF6' : 'rgba(252,250,246,0.5)',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.5s ease',
              padding: 0,
            }}
          />
        ))}
      </div>
    </div>
  );
};

const Catering = () => {
  return (
    <section id="catering" className="py-24 md:py-32 bg-brand-aged px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center">
          <FadeIn className="order-2 md:order-1">
            <CateringCarousel />
          </FadeIn>
          <FadeIn delay={0.2} className="order-1 md:order-2">
            <span className="text-brand-olive uppercase tracking-[0.3em] text-[10px] font-bold mb-6 block">
              The Culinary Experience
            </span>
            <h2 className="font-serif text-3xl md:text-5xl text-brand-charcoal mb-8 leading-tight font-light">
              Cuisine As{' '}
              <span className="italic text-brand-bronze">Amazing</span>{' '}
              As The Views
            </h2>
            <p className="font-sans text-brand-charcoal/80 leading-relaxed font-light mb-8 text-lg">
              We frame our catering as an essential part of your journey. Elegant, flexible, and entirely guest-centered, our menus are designed to complement the historic atmosphere of the estate.
            </p>
            <div className="space-y-6 mb-12">
              {[
                "Elevated plated service for formal celebrations.",
                "Culturally diverse culinary options for milestone events.",
                "Thoughtfully crafted cocktail hour hors d'oeuvres.",
              ].map((text, i) => (
                <div key={i} className="flex gap-5">
                  <div className="w-5 h-[1px] bg-brand-bronze mt-3 shrink-0" />
                  <p className="font-sans text-sm text-brand-charcoal/70 leading-relaxed tracking-wide">
                    {text}
                  </p>
                </div>
              ))}
            </div>
            <a
              href="#contact"
              className="inline-block bg-brand-olive text-brand-vintage px-10 py-5 text-[10px] uppercase tracking-[0.2em] hover:brightness-110 transition-all font-bold shadow-lg"
            >
              Ask About Your Event
            </a>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default Catering;